import EntityContentType from '@/constants/EntityContentType';

export function convertEmailFeedDetailsToEntity(feedDetails) {
  const { datetime: messageDatetime, ...rest } = feedDetails;

  return {
    ...rest,
    messageDatetime,
  };
}

export default function convertFeedDetailsToEntity(entityType, feedDetails) {
  switch (entityType) {
    case EntityContentType.EMAIL_RECEIVED:
    case EntityContentType.EMAIL_SENT:
      return convertEmailFeedDetailsToEntity(feedDetails);
    default:
      return feedDetails;
  }
}
